import type { ReactNode } from 'react';
import { cn } from './cn';

interface BadgeProps {
  children: ReactNode;
  className?: string;
  color?: string;
}

export const Badge = ({ children, className, color }: BadgeProps) => (
  <span
    style={color ? { backgroundColor: color } : undefined}
    className={cn(
      'inline-flex rounded-sm border border-white/20 bg-text px-2.5 py-1 text-[11px] font-semibold uppercase text-white shadow-[var(--shadow-hairline)]',
      className
    )}
  >
    {children}
  </span>
);
